import { required, email, min, max } from "vee-validate/dist/rules.umd.js";
import { extend } from "vee-validate";
import { General } from "@/utils/constants";
import { checkCNPJ, checkCPF } from "@/utils/validate";

extend("required", {
  ...required,
  message: General.MESSAGES.VALIDATE.REQUIRED
});

extend("email", {
  ...email,
  message: General.MESSAGES.VALIDATE.MAIL
});

extend("min", {
  ...min,
  message: General.MESSAGES.VALIDATE.MIN
});

extend("max", {
  ...max,
  message: General.MESSAGES.VALIDATE.MAX
});

extend("url", {
  validate: value =>
    /^(https?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w-.~:/?#[\]@!$&'()*+,;=]+$/gi.test(
      value
    ),
  message: General.MESSAGES.VALIDATE.URL
});

extend("xss", {
  validate: value =>
    !/<\/?script.*>|<\w+.* on\w+=([\w"= ]+)?|javascript:/gi.test(
      value.replace(/[\t\n ]*/g, "")
    ),
  message: General.MESSAGES.VALIDATE.XSS
});

extend("emptyField", {
  ...required,
  params: [
    { name: "text", cast: value => value || General.MESSAGES.VALIDATE.REQUIRED }
  ],
  message: "{text}"
});

extend("cpf", {
  validate: value => checkCPF(value),
  message: General.MESSAGES.VALIDATE.CPF
});

extend("cnpj", {
  validate: value => checkCNPJ(value),
  message: General.MESSAGES.VALIDATE.CNPJ
});
